import '../css/design.less';

require('jquery');
//import '../../theme/One-Pages/assets/plugins/jquery/jquery-migrate.js';
//import $ from "jquery";
import '../../theme/One-Pages/assets/plugins/bootstrap/js/bootstrap.min.js';
import '../../theme/One-Pages/assets/plugins/smoothScroll.js';
//////////import '../../theme/One-Pages/assets/plugins/jquery.easing.min.js';
import '../../theme/One-Pages/assets/plugins/pace/pace.min.js';
import '../../theme/One-Pages/assets/plugins/owl-carousel2/owl.carousel.min.js';
//import '../../theme/One-Pages/assets/plugins/sky-forms-pro/skyforms/js/jquery.form.min.js';
//import '../../theme/One-Pages/assets/plugins/sky-forms-pro/skyforms/js/jquery.validate.min.js';
//import '../../theme/One-Pages/assets/plugins/cube-portfolio/cubeportfolio/js/jquery.cubeportfolio.min.js';
//////////import '../../theme/One-Pages/assets/plugins/modernizr.js';
//import '../../theme/One-Pages/assets/plugins/backstretch/jquery.backstretch.min.js';
require('jquery-backstretch/src/jquery.backstretch.js');
require('js/one.app.js');

import '../../theme/One-Pages/Architecture/assets/js/plugins/pace-loader.js';
//import '../../theme/One-Pages/Architecture/assets/js/plugins/cube-portfolio-lightbox.js';
import '../../theme/One-Pages/assets/plugins/slick/slick.js';
require('./custom');



// WEBPACK FOOTER //
// ./assets/js/app.js